var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVireiNoivaMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rose",
    x1: 94,
    y1: 124,
    x2: 404,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6B6AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B97569"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 188C118 149 149 122 186 122C213 122 236 136 249 160C262 136 285 122 312 122C349 122 380 149 380 188C380 234 347 266 313 299C289 322 264 344 250 374C236 344 212 322 188 299C151 266 118 234 118 188Z",
    stroke: "url(#rose)",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342 118L367 86L404 98L396 138L359 146L342 118Z",
    stroke: "url(#rose)",
    strokeWidth: 11,
    fill: "none",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399 79L410 64M419 84L437 79M422 100L434 114M404 106L403 127",
    stroke: "url(#rose)",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVireiNoivaMark);
export default __webpack_public_path__ + "static/media/virei-noiva-mark.650e7b7d7dfd5d1269e207674cd1a16b.svg";
export { ForwardRef as ReactComponent };